export function initAlert() {
	const alertContain = document.getElementById('alert-container');

	if (alertContain) {
		// Check if there are any alerts for this post id, and add them to the page if so
		const params = new URLSearchParams({
            action: 'get_page_alerts',
            post: alertContain.dataset.post,
        });
		fetch(`${site_data.WP_AJAX}?${params}`)
            .then(response => response.json())
            .then(response => {
                if (!response.success) {
                    throw new Error('Unable to get page alerts data');
                }

				if (response.markup) {
					alertContain.innerHTML = response.markup;
					// Init click events
					const $closeAlertBtn = $('.alert-bar__close');
					$closeAlertBtn.on('click', function (e) {
						e.preventDefault();
						//Fade out message text and close button
						$(this).closest('.alert-bar').find('.container').addClass("fade");
						//Slide up message
						$(this).closest('.alert-bar').delay(250).slideUp();
						// persist the dismissal in a cookie
						document.cookie = $(this).data('alert-cookie');
					});
				}
            })
            .catch(error => console.log(error));
	}
}